import { Box } from "@mui/material";

const LayoutContainer = ({ children, ...props }) => (
    <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 2, md: 10 }, ...props.sx }}>
        {children}
    </Box>
);

export default LayoutContainer;
